import { Navigate } from "react-router-dom";
import MatxLayout from "./components/MatxLayout/MatxLayout";
import ProtectedRoute from "./project/utils/protectedRoute";

import NotFound from "./views/sessions/NotFound";
import Elements from "./views/inicio/Elements";
import LoginComponent from "./project/components/login/LoginComponent";
import GestionAtencionTable from "./project/components/gestion-atencion/GestionAtencionTable"
import DescuentoArmazonTable from "./project/components/descuento-armazon/DescuentoArmazonTable"
import DescuentoAnteojoSolTable from "./project/components/descuento-anteojo-sol/DescuentoAnteojoSolTable";
import DescuentoSolucionLimpiezaTable from "./project/components/descuento-solucion-limpieza/DescuentoSolucionLimpiezaTable";
import DescuentoTratamientoTable from "./project/components/descuento-tratamiento/DescuentoTratamientoTable";
import DescuentoCristalTable from "./project/components/descuento-cristal/DescuentoCristalTable";
import DescuentoLenteContactoTable from "./project/components/descuento-lente-contacto/DescuentoLenteContactoTable";
import CuentaBancariaTable from "./project/components/cuenta-bancaria/CuentaBancariaTable";
import BilleteraTable from "./project/components/billetera/BilleteraTable";
import ObraSocialTable from "./project/components/obra-social/ObraSocialTable";
import ObraSocialPlanTable from "./project/components/obra-social-plan/ObraSocialPlanTable";
import CajaTable from "./project/components/caja/CajaTable";
import Caja from "./project/components/caja/Caja";
import TipoAjusteTable from "./project/components/tipo-ajuste/TipoAjusteTable";
import TipoComprobanteTable from "./project/components/tipo-comprobante/TipoComprobanteTable";
import CobranzaTable from "./project/components/cobranza/CobranzaTable";
import CobranzaVer from "./project/components/cobranza/CobranzaVer";
import FacturaVer from "./project/components/factura/FacturaVer";
import Factura from "./project/components/factura/Factura";
import GestionAtencionCobroProvided from "./project/contexts/GestionAtencionCobroProvided";
import GestionAtencionProvided from "./project/contexts/GestionAtencionProvided";
import OrdenEnvioTable from "./project/components/orden-envio/OrdenEnvioTable";
import RecepcionAnteojoArregloTable from "./project/components/recepcion-anteojo-arreglo/RecepcionAnteojoArregloTable";
import EnvioAnteojoArreglo from "./project/components/recepcion-anteojo-arreglo/EnvioAnteojoArreglo";
import EnvioArticuloTable from "./project/components/envio-articulo/EnvioArticuloTable";
import EnvioArticulo from "./project/components/envio-articulo/EnvioArticulo";
import RecepcionArticuloTable from "./project/components/recepcion-articulo/RecepcionArticuloTable";
import RecepcionArticulo from "./project/components/recepcion-articulo/RecepcionArticulo";
import AjusteArticuloTable from "./project/components/ajuste-articulo/AjusteArticuloTable";
import AjusteArticulo from "./project/components/ajuste-articulo/AjusteArticulo";
import ActividadTable from "./project/components/actividad/ActividadTable";
import AreaTable from "./project/components/area/AreaTable";
import DepartamentoTable from "./project/components/departamento/DepartamentoTable";
import DiagnosticoTable from "./project/components/diagnostico/DiagnosticoTable";
import GeneroTable from "./project/components/genero/GeneroTable";
import TipoDocumentoTable from "./project/components/tipo-documento/TipoDocumentoTable";
import InstitutoTable from "./project/components/instituto/InstitutoTable";
import MedicoTable from "./project/components/medico/MedicoTable";
import OcupacionTable from "./project/components/ocupacion/OcupacionTable";
import PaisTable from "./project/components/pais/PaisTable";
import ParentescoTable from "./project/components/parentesco/ParentescoTable";
import ProveedorTable from "./project/components/proveedor/ProveedorTable";
import ProvinciaTable from "./project/components/provincia/ProvinciaTable";
import TarjetaBancoTable from "./project/components/tarjeta-banco/TarjetaBancoTable";
import TarjetaBancoAcuerdoTable from "./project/components/tarjeta-banco-acuerdo/TarjetaBancoAcuerdoTable";
import TarjetaTable from "./project/components/tarjeta/TarjetaTable";
import TasaIvaTable from "./project/components/tasa-iva/TasaIvaTable";
import ConsultaArticulo from "./project/components/consulta-articulo/ConsultaArticulo";
import CondicionFrenteIvaTable from "./project/components/condicion-frente-iva/CondicionFrenteIvaTable";
import SistemaTable from "./project/components/sistema/SistemaTable";
import SistemaRolTable from "./project/components/sistema-rol/SistemaRolTable";
import SistemaPermisoTable from "./project/components/sistema-permiso/SistemaPermisoTable";
import SistemaRolPermiso from "./project/components/sistema-rol-permiso/SistemaRolPermiso";
import UsuarioTable from "./project/components/usuario/UsuarioTable";
import SistemaRolUsuario from "./project/components/sistema-rol-usuario/SistemaRolUsuario";
import CambioPassword from "./project/components/password/CambioPassword";

const routes = [
  {
    element: (
      <ProtectedRoute>
        <MatxLayout />
      </ProtectedRoute>
    ),
    children: [
      { path: "/inicio", element: <Elements /> },
      { path: "/consulta-articulos", element: <ConsultaArticulo /> },
      { path: "/gestion-atencion/:idGestionAtencion/:action", element: <GestionAtencionProvided /> },
      { path: "/gestion-atencion-table", element: <GestionAtencionTable /> },
      { path: "/gestion-atencion-cobro/:arrayGAs", element: <GestionAtencionCobroProvided /> },
      { path: "/cobranza-table", element: <CobranzaTable /> },
      { path: "/descuento-armazon-table", element: <DescuentoArmazonTable /> },
      { path: "/descuento-anteojo-sol-table", element: <DescuentoAnteojoSolTable /> },
      { path: "/descuento-solucion-limpieza-table", element: <DescuentoSolucionLimpiezaTable /> },
      { path: "/descuento-tratamiento-table", element: <DescuentoTratamientoTable /> },
      { path: "/descuento-cristal-table", element: <DescuentoCristalTable /> },
      { path: "/descuento-lente-contacto-table", element: <DescuentoLenteContactoTable /> },
      { path: "/cuenta-bancaria-table", element: <CuentaBancariaTable /> },
      { path: "/billetera-table", element: <BilleteraTable /> },
      { path: "/obra-social-table", element: <ObraSocialTable /> },
      { path: "/obra-social-plan-table", element: <ObraSocialPlanTable /> },
      { path: "/cajas-table", element: <CajaTable /> },
      { path: "/caja/:idCaja/:action", element: <Caja /> },
      { path: "/tipo-ajuste-table", element: <TipoAjusteTable /> },
      { path: "/tipo-comprobante-table", element: <TipoComprobanteTable /> },
      { path: "/cobranza/:idCobranza/:action", element: <CobranzaVer /> },
      { path: "/factura-ver/:idFactura/", element: <FacturaVer /> },
      { path: "/factura/:idCobranza/", element: <Factura /> },
      { path: "/orden-envio-table", element: <OrdenEnvioTable /> },
      { path: "/recepcion-anteojo-arreglo-table", element: <RecepcionAnteojoArregloTable /> },
      { path: "/recepcion-anteojo-arreglo/:action/:idEnvioAnteojoArreglo", element: <EnvioAnteojoArreglo /> },
      { path: "/envio-articulo-table", element: <EnvioArticuloTable /> },
      { path: "/envio-articulo/:idEnvio/:action", element: <EnvioArticulo /> },
      { path: "/envio-articulo/:action", element: <EnvioArticulo /> },
      { path: "/recepcion-articulo-table", element: <RecepcionArticuloTable /> },
      { path: "/recepcion-articulo/:idEnvio/:action", element: <RecepcionArticulo /> },
      { path: "/recepcion-articulo/:action", element: <RecepcionArticulo /> },
      { path: "/ajuste-articulo-table", element: <AjusteArticuloTable /> },
      { path: "/ajuste-articulo/:idAjuste/:action", element: <AjusteArticulo /> },
      { path: "/ajuste-articulo/:action", element: <AjusteArticulo /> },
      { path: "/area-table", element: <AreaTable /> },
      { path: "/condicion-frente-iva-table", element: <CondicionFrenteIvaTable /> },
      { path: "/proveedor-table", element: <ProveedorTable /> },
      { path: "/actividad-table", element: <ActividadTable /> },
      { path: "/ocupacion-table", element: <OcupacionTable /> },
      { path: "/diagnostico-table", element: <DiagnosticoTable /> },
      { path: "/genero-table", element: <GeneroTable /> },
      { path: "/medico-table", element: <MedicoTable /> },
      { path: "/instituto-table", element: <InstitutoTable /> },
      { path: "/tarjeta-table", element: <TarjetaTable /> },
      { path: "/tarjeta-banco-table", element: <TarjetaBancoTable /> },
      { path: "/tarjeta-banco-acuerdo-table", element: <TarjetaBancoAcuerdoTable /> },
      { path: "/departamento-table", element: <DepartamentoTable /> },
      { path: "/provincia-table", element: <ProvinciaTable /> },
      { path: "/pais-table", element: <PaisTable /> },
      { path: "/tasa-iva-table", element: <TasaIvaTable /> },
      { path: "/tipo-documento-table", element: <TipoDocumentoTable /> },
      { path: "/parentesco-table", element: <ParentescoTable /> },
      { path: "/sistema-table", element: <SistemaTable /> },
      { path: "/sistema-rol-table", element: <SistemaRolTable /> },
      { path: "/sistema-permiso-table", element: <SistemaPermisoTable /> },
      { path: "/sistema-rol-permiso", element: <SistemaRolPermiso /> },
      { path: "/usuario-table", element: <UsuarioTable /> },
      { path: "/sistema-rol-usuario", element: <SistemaRolUsuario /> },
      { path: "/cambio-password", element: <CambioPassword /> },
    ]
  },
  { path: "/session/404", element: <NotFound /> },
  { path: "/login", element: <LoginComponent /> },
  { path: "/", element: <Navigate to="inicio" /> },
  { path: "*", element: <LoginComponent /> }
];
export default routes;
